import { z } from 'zod'

export const WorkflowFormEntitySchema = z.object({
  name: z.string(),
  type: z.enum(['publish', 'order']),
  steps: z.array(
    z.object({
      label: z.string(),
      primaryRoleIds: z.array(z.number()),
      secondaryRoleIds: z.array(z.number()).optional(),
      isApproverAddable: z.boolean(),
      multiApproverCondition: z.string().optional(),
    })
  ),
})

export type WorkflowFormEntity = z.infer<typeof WorkflowFormEntitySchema>
